import React, {Component} from 'react';
//import io from 'socket.io-client';
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import {

    FaAngleLeft, HiUserGroup, IoHelpBuoySharp, IoNewspaperOutline,
    MdOutlineContactPhone, MdOutlineInfo,
    TbHelpOctagon,

} from "react-icons/all";
import {NavLink} from "react-router-dom";

class Profile extends Component {
    state = {
        isLoaded: false,
    }

    render() {
        return (
            <React.Fragment>

                {
                    !this.state.isLoaded && <Loading />
                }
<Actionbar title='' noBack={1}/>

                <nav className="container-fluid profile-list-items mt-5 pt-5">
                    <div className="col-12 pt-2 ">

                    </div>

                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/نمایندگی-ها" >

                        <div className="col-1">
                            <HiUserGroup className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                          لیست نمایندگی ها
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/درباره-ما" >

                        <div className="col-1">
                            <MdOutlineInfo className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                          درباره تلکارنت
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/اطلاعات-تماس" >

                        <div className="col-1">
                            <MdOutlineContactPhone className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                          ارتباط با ما
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/اخبار" >

                        <div className="col-1">
                            <IoNewspaperOutline className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                         اخبار و اطلاعیه ها
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/راهنما" >

                        <div className="col-1">
                            <IoHelpBuoySharp className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                         راهنما
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/contents/سوالات-متداول" >

                        <div className="col-1">
                            <TbHelpOctagon className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                            سوالات متداول
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>



                </nav>

                <Navbar />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        setTimeout (() => {
            this.setState({isLoaded : true})
            window.scrollTo({top: 0, behavior: 'smooth'});
        },5)

    }
}

export default Profile;